import { TFunction } from 'i18next';

import {
  BoardMineralization,
  BoardSoil,
  BoardStatus,
} from 'features/Croptimizer/types';
import { numericValues } from 'utils/helpers';
import { getEfficiencyFormula } from 'features/Croptimizer/utils/calcHelperBoard';

interface Props {
  getY4CurrentProfit?: string | number;
  mineralizationValues: BoardMineralization | null;
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
  optimumValue: number;
  t: TFunction;
}

export const Y5CurrentProfitSecond = ({
  getY4CurrentProfit,
  boardStatusValues,
  mineralizationValues,
  boardSoilValues,
  optimumValue,
  t,
}: Props) => {
  const getSec = (
    ((Math.tan((Number(getY4CurrentProfit) - 5.8) / 1.45) * 54 + 70) /
      100 /
      0.05) *
    5
  ).toFixed(2);

  const ag38 = getEfficiencyFormula(
    Number(mineralizationValues?.month),
    Number(boardStatusValues?.currentPh),
    Number(numericValues(boardStatusValues?.currentSec ?? '')),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ah38 = getEfficiencyFormula(
    24,
    Number(getY4CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ai38 = getEfficiencyFormula(
    36,
    Number(getY4CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const aj38 = getEfficiencyFormula(
    48,
    Number(getY4CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );
  const ak38 = getEfficiencyFormula(
    60,
    Number(getY4CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );

  const ag31 = ag38;
  const ah31 = ah38 < ag31 ? ag31 : ah38;
  const ai78 = ah31 / 100;
  const ah78 = ag31 / 100;
  const ai71 = ai78 - ah78;
  const ah71 = ah78;
  const dose = Number(numericValues(boardSoilValues?.dose ?? '')) / 100;
  const ai79 = ah31 / 100;
  const ai31 = ai38 < ah31 ? ah31 : ai38;
  const aj78 = ai31 / 100;
  const aj71 = aj78 - ai78;
  const aj79 = ai31 / 100;
  const aj72 = aj79 - ai79;
  const aj31 = aj38 < ai31 ? ai31 : aj38;
  const ajj78 = aj31 / 100;
  const ak71 = ajj78 - aj78;
  const ak81 = aj31 / 100;
  const ah81 = ag31 / 100;
  const ah74 = ah81;

  const ah80 = ag31 / 100;
  const ai80 = ah31 / 100;
  const ai73 = ai80 - ah80;
  const ak80 = aj31 / 100;

  const ak79 = aj31 / 100;
  const ak82 = aj31 / 100;
  const ak31 = ak38 < aj31 ? aj31 : ak38;
  const al78 = ak31 / 100;
  const ak78 = aj31 / 100;
  const al71 = al78 - ak78;
  const al79 = ak31 / 100;
  const al72 = al79 - ak79;
  const al80 = ak31 / 100;
  const al73 = al80 - ak80;
  const al81 = ak31 / 100;
  const al74 = al81 - ak81;
  const al82 = ak31 / 100;
  const al75 = al82 - ak82;
  const annualDecrease = Number(mineralizationValues?.annualDecrease);
  const frequency = Number(boardSoilValues?.split);

  if (mineralizationValues?.cap !== t('no')) {
    if (boardSoilValues?.split === '1') {
      const al87 = ah71 + ai71 + aj71 + ak71 + al71;
      const calculatedq64 = (annualDecrease * dose * frequency * al87).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const al88 = al72 + aj72;
      const calculatedq65 = (annualDecrease * dose * frequency * al88).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const al89 = ai73 + al73;
      const calculatedq65 = (annualDecrease * dose * frequency * al89).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY4CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const al90 = al74 + ah74;
      const calculatedq65 = (annualDecrease * dose * frequency * al90).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const al91 = al75;
      const calculatedq65 = (annualDecrease * dose * frequency * al91).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY4CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }
  } else {
    if (boardSoilValues?.split === '1') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const p64MinusAnnual =
        Number(getY4CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY4CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const p64MinusAnnual =
        Number(getY4CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + 0).toFixed(2);
    }
  }
};
